import './Chip.scss'
import React from 'react'

interface ChipProps {
  children: React.ReactNode
  variant?: 'default' | 'outline'
}

const Chip = ({ children, variant = 'default' }: ChipProps) => (
  <span className={`chip chip--${variant}`}>{children}</span>
)

export default Chip
